import { AssetQuery } from './Asset.query';

const Asset = () => {
  return <AssetQuery />;
};

export { Asset };
